import { useState } from 'react';
import { CustomerScanData, InbodyCustomerInfo } from '../interfaces/customerInbodyData';
import { nutritionScanService } from '../services/scanService/nutritionScanService';

export type UseCustomerScanReturn = {
  scanData: CustomerScanData | null | undefined;
  isScanUnavailable: boolean;
  /** resolves with the customer LookInBody matched, null when no scan was found */
  getScanData: (inbodyId: number | string) => Promise<InbodyCustomerInfo | null>;
};

export const useCustomerScan = (): UseCustomerScanReturn => {
  const [scanData, setScanData] = useState<CustomerScanData | null | undefined>(
    undefined,
  );

  const getScanData = async (inbodyId: number | string) => {
    try {
      const { prefillReading, customer } =
        await nutritionScanService.getScanDataByInbodyId(inbodyId, [404]);

      setScanData(prefillReading);

      return customer;
    } catch {
      setScanData(null);

      return null;
    }
  };

  const isScanUnavailable = scanData === null;

  return { scanData, isScanUnavailable, getScanData };
};
